<!-- @format -->

<template>
  <div class="ui segment">
    <div class="ui">
      Portfolio
      <i
        class="square full icon"
        :style="'color: ' + appearanceSettings.appearanceSchema.barColor1"
      ></i>
      vs ASISA
      <i
        class="square full icon"
        :style="'color: ' + appearanceSettings.appearanceSchema.barColor2"
      ></i>
    </div>
    <div style="float: right" class="ui tiny basic buttons">
      <button
        :class="performanceType == 'Annual' ? 'ui active button' : 'ui button'"
        @click.prevent="changePerformanceType('Annual')"
      >
        Yearly
      </button>
      <button
        :class="performanceType == 'Growth' ? 'ui active button' : 'ui button'"
        @click.prevent="changePerformanceType('Growth')"
      >
        Cumulative
      </button>
    </div>
    <br />

    <dx-chart
      id="performances"
      style="max-height: 220px; height: 220px"
      :data-source="activeDataSource"
      :customize-point="customizePoint"
    >
      <dx-common-axis-settings>
        <dx-label>
          <dx-font color="black" />
        </dx-label>
      </dx-common-axis-settings>

      <dx-legend :visible="false">
        <dx-font color="black" />
      </dx-legend>
      <dx-series
        v-if="performanceType != 'Growth'"
        argument-field="friendlyDate"
        value-field="trr"
        type="bar"
        name="Portfolio"
        :color="appearanceSettings.appearanceSchema.barColor1"
      />
      <dx-series
        v-if="performanceType != 'Growth'"
        argument-field="friendlyDate"
        value-field="asisaTrr"
        type="bar"
        name="ASISA Average"
        :color="appearanceSettings.appearanceSchema.barColor2"
      />

      <dx-series
        v-if="performanceType == 'Growth'"
        argument-field="friendlyDate"
        value-field="trr"
        name="Portfolio"
        type="line"
        :color="appearanceSettings.appearanceSchema.barColor1"
      />
      <dx-series
        v-if="performanceType == 'Growth'"
        argument-field="friendlyDate"
        value-field="asisaTrr"
        name="ASISA Average"
        type="line"
        :color="appearanceSettings.appearanceSchema.barColor2"
      />
      <dx-tooltip :enabled="true" :customize-tooltip="customizeTooltip" />
    </dx-chart>

    <br />
    <br />
    <div class="ui horizontal divider">Historical Performance Stats ⭐</div>

    <table style="font-size: small" class="ui very compact table">
      <thead>
        <tr>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tr v-if="performanceType != 'Growth'">
        <td>Lowest 1 year rolling return</td>

        <td>
          {{ selectedPortfolio.minAnnualPerformance }}
        </td>
      </tr>
      <tr v-if="performanceType != 'Growth'">
        <td>Highest 1 year rolling return</td>
        <td style="vertical-align: center">
          {{ selectedPortfolio.maxAnnualPerformance }}
        </td>
      </tr>

      <tr v-if="performanceType == 'Growth'">
        <td>Cumulative Performance - Portfolio</td>
        <td style="vertical-align: center">
          {{
            annualise(
              (activeDataSource[activeDataSource.length - 1].trr - 1000) / 100,
              activeDataSource.length
            )
          }}

          <small>
            as at
            {{ friendlyDate(max(activeDataSource, "endDate").endDate) }}
          </small>
        </td>
      </tr>
      <tr v-if="performanceType == 'Growth'">
        <td>Cumulative Performance - ASISA</td>
        <td style="vertical-align: center">
          {{
            annualise(
              (activeDataSource[activeDataSource.length - 1].asisaTrr - 1000) /
                100,
              activeDataSource.length
            )
          }}

          <small>
            as at
            {{ friendlyDate(max(activeDataSource, "endDate").endDate) }}
          </small>
        </td>
      </tr>
    </table>

    <small v-if="false"> annualised figures</small>
  </div>
</template>
<script>
import numeral from "numeral";

import moment from "moment";
import * as _ from "lodash";
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxLabel,
  DxFont,
} from "devextreme-vue/chart";
export default {
  name: "Positions",
  props: {
    appearanceSettings: Object,
    selectedPortfolio: Object,
    show: Boolean,
  },
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxCommonAxisSettings,
    DxCommonSeriesSettings,
    DxGrid,
    DxMargin,
    DxLabel,
    DxLegend,
    DxTick,
    DxTooltip,
    DxFont,
  },
  data() {
    return {
      performanceType: "Annual",
      pointIncomeOptions: { visible: false },
    };
  },

  computed: {
    activeDataSource: function () {
      let positions = this.selectedPortfolio.positions;

      let finalAa = [];
      var final = [];
      let cpid = this.selectedPortfolio.customPortfolioId;

      if (this.selectedPortfolio.yearlyPerformances) {
        switch (this.performanceType) {
          /* case "Monthly": {
          for (
            var i = 0;
            i < this.selectedPortfolio.monthlyPerformances.length;
            i++
          ) {
            var performance = this.selectedPortfolio.monthlyPerformances[i];
            performance.friendlyDate = this.friendlyDate(performance.endDate);
            performance.performanceType = this.performanceType;
            final.push(performance);
          }
          return final;
        }*/
          case "Annual": {
            for (
              var i = 0;
              i < this.selectedPortfolio.yearlyPerformances.length;
              i++
            ) {
              var performance = this.selectedPortfolio.yearlyPerformances[i];
              performance.performanceType = this.performanceType;
              performance.friendlyDate = this.friendlyDate(performance.endDate);
              final.push(performance);
            }
            break;
          }
          case "Growth": {
            for (
              var i2 = 0;
              i2 < this.selectedPortfolio.cumulativePerformances.length;
              i2++
            ) {
              var performance2 = this.selectedPortfolio.cumulativePerformances[
                i2
              ];
              performance2.performanceType = this.performanceType;
              performance2.friendlyDate = this.friendlyDate(
                performance2.endDate
              );
              final.push(performance2);
            }
            break;
          }
        }
      }
      return final;
    },
  },
  methods: {
    annualise(trr, months) {
      if (months > 12) {
        return this.formatNr(
          Number(Math.pow(Number(1 + trr), Number(12 / months)) - 1),
          "0,0.0%"
        );
      } else return this.formatNr(trr, "0,0.0%");
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg, "YYYYMMDD").format("MMM YYYY");
    },
    customizePoint(arg) {
      if (this.performanceType == "Growth") {
        return {
          visible: false,
          color: "#ff7c7c",
          hoverStyle: { color: "#ffffff" },
        };
      }
    },
    customizeTooltip: (arg) => {
      return {
        text:
          "<h2><strong >  " +
          arg.argument +
          " </strong></h2> <br /><span>" +
          arg.seriesName +
          ":  " +
          (arg.point.data.performanceType == "Growth"
            ? "R" + numeral(arg.value).format("0,0")
            : numeral(arg.value).format("0,0.0%")) +
          "" +
          "</span>",
      };
    },
    changePerformanceType: function (val) {
      this.performanceType = val;
    },
    min(arr, val) {
      return _.minBy(arr, val);
    },
    max(arr, val) {
      return _.maxBy(arr, val);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.00a");
    },
  },
  async mounted() {},
};
</script>
